import { render, staticRenderFns } from "./LeaveRequestModalNew.vue?vue&type=template&id=21b9659e&scoped=true"
import script from "./LeaveRequestModalNew.vue?vue&type=script&lang=js"
export * from "./LeaveRequestModalNew.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequestModalNew.vue?vue&type=style&index=0&id=21b9659e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9659e",
  null
  
)

export default component.exports